import { action, makeAutoObservable, observable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
import feedbackService from "@services/feedback/feedbackService"

class FeedbackStore {
  @observable isLoading: boolean = false
  @observable detailData!: any
  @observable tableData: PagedResultDto<any> = { items: [], totalCount: 0 }
  @observable customerComboBox: any = {items: [], totalCount: 0}
  @observable internalMessage: any = {items: [], totalCount: 0}
  @observable dashboardStatus: any = {result: []}
  @observable auditLogData!: any
  constructor() {
    makeAutoObservable(this)
    this.detailData = {}
    this.tableData = { items: [], totalCount: 0 }
    this.customerComboBox = {items: [], totalCount: 0}
    this.auditLogData = {}
  }

  @action
  async createOrUpdate(body: any) {
    if (!body.id) {
      const result = await feedbackService.create(body)
      this.detailData = result
      this.tableData.items.push(result)
    } else {
      const result = await feedbackService.update(body)
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
  }

  @action
  async initDetail() {
    this.detailData = {
      id: undefined,
    }
  }

  @action
  async delete(id: number) {
    await feedbackService.delete(id)
    this.tableData.items = this.tableData.items.filter((x) => x.id !== id)
  }

  @action
  async get(id: number) {
    const result = await feedbackService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await feedbackService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getAllCustomerComboBox(params: any) {
    this.isLoading = true
    const result = await feedbackService.getGetAllCustomerComboBox(params)
    this.customerComboBox = result
    this.isLoading = false
  }

  @action
  async getInternalMessage(params: any) {
    this.isLoading = true
    const result = await feedbackService.getInternalMessage(params)
    this.internalMessage = result
    this.isLoading = false
  }

  @action
  async createInternalMessage(body: any) {
    this.isLoading = true
    try {
      return await feedbackService.createInternalMessage(body)
    } finally {
      this.isLoading = false
    }
  }

  @action
  clearInternalMessage() {
    this.internalMessage = { items: [], totalCount: 0 }
  }

  @action
  async getDashboardStatus(params: any) {
    this.isLoading = true
    const result = await feedbackService.getDashboardStatus(params)
    this.dashboardStatus = { result: result }
    this.isLoading = false
    return result
  }

  @action
  async exportFeedback(params: any) {
    this.isLoading = true
    try {
      return await feedbackService.exportFeedback(params)
    } finally {
      this.isLoading = false
    }
  }

  @action
  async activeFeedback(params: any) {
    this.isLoading = true
    const result = await feedbackService.activeFeedback(params)
    return result
  }

  @action
  async getAuditLog(id: number) {
    const result = await feedbackService.getAuditLog(id)
    this.auditLogData = result
  }
}

export default FeedbackStore
